import React from 'react';
import { useFormContext } from 'react-hook-form';
import FieldError from '../../../shared/fields-errors/field-error';
import "./donation-widget.scss";

function ChargeFixedNumberOfTime(props) {
    const { register, formState: { errors }, watch } = useFormContext();
    const fields = watch();

    const getFrequencyUnit = (frequency, count) => {
        const isPlural = parseInt(count || 1) !== 1;
switch (frequency) {
        case 'Daily':
            return isPlural ? 'days' : 'day';
        case 'Weekly':
            return isPlural ? 'weeks' : 'week';
        case 'Monthly':
            return isPlural ? 'months' : 'month';
        case 'Quarterly':
            return isPlural ? 'quarters' : 'quarter';
        case 'Annually':
            return isPlural ? 'years' : 'year';
        case 'Every-Jumuah':
            return isPlural ? 'weeks' : 'week';
        default:
            return isPlural ? 'months' : 'month';
}
    };

    return (
        <>
            <div className='col-lg-12 d-flex justify-content-center mt-3 px-2'>
                {/* <div className={`form-group ${props?.descriptiveAmountView ? 'w-100' : 'w-75'}`}> */}
                <div className={`form-group w-100`}>
                    <label className="form-control-label d-flex align-items-center" style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        lineHeight: '1.4',
                        color: '#555',
                        gap: '8px',
                        cursor: 'pointer'
                    }}>
                        <input {...register('is_charge_number_of_times', {
                            value: false
                        })} className="recurring-form-check" type="checkbox"
                         style={{ '--checkbox-color': props?.primaryColor || "#155C4E", marginTop: '-3px' }}
                        />
                        Set a duration
                    </label>
                   {
                    fields?.is_charge_number_of_times ?
                        <>
                            <div className='d-flex justify-content-start align-items-center mt-2 gap-2'>
                                <span style={{ fontSize: '13px', fontWeight: '600', color: '#555' }}>Donate for</span>
                                <input placeholder=""
                                {...register('recurring_option_value', {
                                    value: 1,
                                        validate: {
                                            required: value => {
                                                if (!value) return "This field is required";
                                                return true
                                            },
                                            min: value => {
                                                if (value <= 1) {
                                                    return `Value cannot be less then or equal to 1`
                                                };
                                                return true;
                                            }
                                        }
                                            })} 
                                    type="number"  className="recurring-form-input form-control"  min={1}
                                    style={{'--border-color': props?.primaryColor || '#ccc', width: '70px'}} />
                                <span style={{ fontSize: '13px', fontWeight: '600', color: '#555' }}> {getFrequencyUnit(props?.donationFrequency, fields?.recurring_option_value)} </span>
                            </div>
                        </> : ''
                  }
                </div>
            </div>
            <div className='text-center'>
            {errors?.recurring_option_value ? <FieldError message={errors?.recurring_option_value?.message} /> : ''}
            </div>
        </>
    );
}

export default ChargeFixedNumberOfTime;